import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';

export const finmaRoutes: Routes = [
  {
    path: 'finma-registration',
    title: 'WEB_WIZARD_COMMUNITY_NEW_STEP_1',
    loadComponent: () =>
      import('./pages/finma-registration.component').then(
        (m) => m.FinmaRegistrationComponent
      ),
    resolve: {
      agorai18n: i18nResolver,
    },
    data: { navigationRoute: ROUTE_NAMES.FINMA_REGISTRATION },
  },
  {
    path: 'finma-communities',
    title: 'WEB_FINMA_CHOOSE_COMMUNITY',
    loadComponent: () =>
      import('./pages/finma-communities.component').then(
        (m) => m.FinmaCommunitiesComponent
      ),
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    data: { navigationRoute: ROUTE_NAMES.FINMA_COMMUNITIES },
  },
];
